import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material';
import { NotificationComponent } from '../../../core/notification/notification.component';

export enum NotificationLevel {
  SUCCESS = 'success',
  INFO = 'info',
  WARNING = 'warning',
  ERROR = 'error',
}

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {

  closeText: string;

  constructor(
    private matSnackBar: MatSnackBar,
  ) {
  }

  showNotification(message: string, level: NotificationLevel = NotificationLevel.INFO) {
    const config: MatSnackBarConfig = {
      duration: 5000,
      panelClass: `panel-${level}`,
      data: {
        message,
        snackType: level,
      }
    };

    this.matSnackBar.openFromComponent(NotificationComponent, config);
  }

  showNotificationWithDuration(message: string, level: NotificationLevel = NotificationLevel.INFO, duration: number) {
    const config: MatSnackBarConfig = {
      duration,
      panelClass: `panel-${level}`,
      data: {
        message,
        snackType: level,
      }
    };

    this.matSnackBar.openFromComponent(NotificationComponent, config);
  }
}

